import { gql, useQuery } from '@apollo/client';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

export const GET_GANTTS = gql`
  query getGantts($companyId: String!) {
    getGantts(companyId: $companyId) {
      _id
      name
      holidayLocationId
      holidayLocation {
        _id
        name
      }
      colorSchema {
        holidayColor
        todayColor
        weekendColor
      }
      weekends
    }
  }
`;

export const useGetGantts = () => {
  const currentCompanyId = useGetCurrentCompanyId();
  const { data, loading } = useQuery(GET_GANTTS, {
    variables: { companyId: currentCompanyId },
    skip: !currentCompanyId,
  });
  const gantts = data?.getGantts || [];

  return { loading, gantts };
};
